// get product data
const product = JSON.parse(document.querySelector(".productV8JSON").textContent);
let activeVariant = JSON.parse(document.querySelector(".variantV8JSON").textContent);

/**************
 Product Swiper
 **************/
    // setup product swiper
let productSwiper = null;

function initSwiper() {
    // re-init will replace the productSwiper
    productSwiper = new Swiper(document.querySelector(".productV8VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        zoom: {
            maxRatio: 2
        },
        navigation: {
            nextEl: '.productV8VisualSwiper .swiper-button-next',
            prevEl: '.productV8VisualSwiper .swiper-button-prev',
        },
    });

    // slide change
    productSwiper.on('slideChange', function () {
        // update the thumbnail active class
        document.querySelectorAll(".productV8VisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
        document.querySelectorAll(`.productV8VisualThumbsSlide[data-index="${productSwiper.activeIndex + 1}"]`).forEach(el => el.classList.add("active"));

        // pause all videos
        document.querySelectorAll(".productV8VisualSwiperSlide video").forEach(element => {
            element.pause();
        });
    });

    // play video on slide play click
    document.querySelectorAll(".productV8VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV8VisualSwiperSlide").querySelector("video");

            // remove play button if it hasn't already been removed
            this.querySelector(".productV8VisualSwiperSlidePlay")?.remove();

            if (video) {
                // show controls
                video.controls = true;

                // play video
                video.play();
            }
        });
    });

    // change slide on thumbnail click
    document.querySelectorAll(".productV8VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // mobile thumbnail swiper
    const thumbnailSwiper = new Swiper(document.querySelector(".productV8VisualThumbs .swiper"), {
        slidesPerView: 'auto',
        navigation: {
            nextEl: '.productV8VisualThumbs .swiper-button-next',
            prevEl: '.productV8VisualThumbs .swiper-button-prev',
        },
    });

    // mobile active add
    document.querySelectorAll(".productV8VisualThumbsSlide.swiper-slide").forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('.productV8VisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
            this.classList.add('active');
        });
    });
}

// check for variant galleries
const variantGalleries = !!document.querySelector('.productV8VisualSwiper');

// initialize the swiper if there is a variant gallery
if (variantGalleries) {
    initSwiper();
}

// main product swiper
const mainSwiper = new Swiper(document.querySelector(".productV8VisualMainSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    zoom: {
        maxRatio: 2
    },
    navigation: {
        nextEl: '.productV8VisualMainSwiper .swiper-button-next',
        prevEl: '.productV8VisualMainSwiper .swiper-button-prev',
    },
});

// slide change
mainSwiper.on('slideChange', function () {
    // update the thumbnail active class
    document.querySelectorAll(".productV8VisualMain .productV8VisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
    document.querySelectorAll(`.productV8VisualMain .productV8VisualThumbsSlide[data-index="${mainSwiper.activeIndex + 1}"]`).forEach(el => el.classList.add("active"));

    // pause all videos
    document.querySelectorAll(".productV8VisualSwiperSlide video").forEach(element => {
        element.pause();
    });
});

// play video on slide play click
document.querySelectorAll(".productV8VisualMain .productV8VisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productV8VisualMain .productV8VisualSwiperSlide").querySelector("video");

        // remove play button if it hasn't already been removed
        this.querySelector(".productV8VisualMain .productV8VisualSwiperSlidePlay")?.remove();

        if (video) {
            // show controls
            video.controls = true;

            // play video
            video.play();
        }
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productV8VisualMain .productV8VisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        mainSwiper.slideTo(this.dataset.index - 1);
    });
});

// mobile thumbnail swiper
const mainThumbnailSwiper = new Swiper(document.querySelector(".productV8VisualMainSwiperThumbs .swiper"), {
    slidesPerView: 'auto',
    // loop: true,
    navigation: {
        nextEl: '.productV8VisualMainSwiperThumbs .swiper-button-next',
        prevEl: '.productV8VisualMainSwiperThumbs .swiper-button-prev',
    },
});

// mobile active add
document.querySelectorAll(".productV8VisualThumbsSlide.swiper-slide").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('.productV8VisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
        this.classList.add('active');
    });
});

// View all button swaps to main images
if (document.querySelector('.productV8Gallery')) {
    document.querySelector('.productV8Gallery').addEventListener("click", () => {
        document.querySelector('.productV8Visual').classList.add('mainVisual');
    })
}

// clicking an already selected color will show variant gallery again
// only apply if variant galleries
if (variantGalleries) {
    document.querySelectorAll('.productV8OptionItemValuesLabel').forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('.productV8Visual').classList.remove('mainVisual');
        })
    })
}

/**************
 Product Quantity
 ***************/

// update quantity inputs on buttons
document.querySelector('.productV8FormQuantity').addEventListener("click", function (e) {
    const target = e.target.closest('.productV8FormQuantityButton');
    if (target) {
        let quantity = document.querySelector(".productV8FormQuantityInput").value;
        if (target.classList.contains('productV8FormQuantityButtonLess') && quantity > 1) {
            quantity--
        } else if (target.classList.contains('productV8FormQuantityButtonMore')) {
            quantity++
        }
        // update both form hidden inputs
        document.querySelector(".productV8FormQuantityInput").value = quantity;
        document.querySelector(".productV8BottomQuantityInput").value = quantity;
        // update the display
        document.querySelector(".productV8FormQuantityNumberDisplay").textContent = String(quantity);
    }
})

// update quantity on sticky bar input
document.querySelector(".productV8BottomQuantityInput")?.addEventListener("input", function () {
    document.querySelector(".productV8FormQuantityInput").value = this.value;
    document.querySelector(".productV8FormQuantityNumberDisplay").textContent = String(this.value);
});

/**************
 Product Variants
 ***************/

// variable for the product form element
const productFormATC = document.querySelector(".productV8FormATC");

// update active variant on input changes
document.querySelectorAll(".productV8OptionItemValuesLabel").forEach(function (element) {
    element.addEventListener("input", function () {

        //update bottom ATC to match top
        const value = element.querySelector('input').value;
        const name = element.querySelector('input').name;
        document.querySelector(`.productV8BottomRight select[name="${name}"]`).value = value;

        updateBottomVariant();
        updateUnavailableOptions();
        updateProduct().catch(e => console.error(e));
    });
})

// update active variant
async function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV8OptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    if (options.length !== 0) {
        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {

        // try to find new size
        const foundNewSize = nextAvailableSize();

        // fall back if no sizes available
        if (!foundNewSize) {
            productFormATC.classList.add("disabled");
            productFormATC.textContent = "Not Available";
        }
        // return no matter what
        return;
    }

    // update variant
    document.querySelector('.productV8FormVariant').value = activeVariant.id;

    // update color title if available
    if (document.querySelector('.productV8OptionItemValues.color') && document.querySelector('.productV8OptionItemLabelTitle')) {
        document.querySelector('.productV8OptionItemLabelTitle').textContent = document.querySelector('.productV8OptionItemValues.color .productV8OptionItemValuesLabelInput:checked').value;
    }

    // update intelligems id
    document.querySelectorAll('.productV8PriceReal, .productV8PriceCompare, .productV8PriceSavings').forEach(el => {
        el.setAttribute('data-variant-id', activeVariant.id);
    });

    // update price
    document.querySelector(".productV8PriceReal").textContent = price(activeVariant.price);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector(".productV8PriceReal").classList.add("sale");
        document.querySelector(".productV8PriceCompare").textContent = price(activeVariant.compare_at_price);
        document.querySelector(".productV8PriceSavings").textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`;
    } else {
        document.querySelector(".productV8PriceReal").classList.remove("sale");
        document.querySelector(".productV8PriceCompare").textContent = "";
        document.querySelector(".productV8PriceSavings").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        productFormATC.classList.remove("disabled");
        productFormATC.textContent = "Add To Cart";
    } else {
        // for multi-option products (e.g. color + size), try to find an available size
        if (product.options.length > 1) {
            const foundNewSize = nextAvailableSize();
            if (foundNewSize) {
                return;
            }
        }
        productFormATC.classList.add("disabled");
        productFormATC.textContent = "Sold Out";
    }

    try {
        // update afterpay variant
        afterpay_current_variant = activeVariant;

        // update display price
        const afterpayElement = document.querySelector('[data-mpid="muscle-mat.myshopify.com"]');
        if (afterpayElement) afterpayElement.dataset.amount = activeVariant.price / 100;
    } catch (e) {
        console.error("Error updating afterpay pricing")
    }

    try {
        // if page with has variant gallery, update and show the variant specific images
        if (variantGalleries) {
            let path = window.location.pathname;
            const response = await fetch(`${path}${path.includes('?') ? "&" : "?"}variant=${activeVariant.id}&sections=main-product-v8`)
            if (response.ok) {
                const data = await response.json();
                const content = data["main-product-v8"]
                // create a new element and parse out contents
                const contentDiv = document.createElement('div');
                contentDiv.innerHTML = content;
                const newSwiper = contentDiv.querySelector('.productV8VisualVariant').innerHTML;
                // destroy old swiper and update with new media
                if (newSwiper) {
                    await productSwiper.destroy(true, true);
                    document.querySelector('.productV8VisualVariant').innerHTML = contentDiv.querySelector('.productV8VisualVariant').innerHTML;
                    // run the event listeners
                    initSwiper();
                    // show the variant swiper
                    document.querySelector('.productV8Visual').classList.remove('mainVisual');
                }
            }
        } else {
            // no special selector, try to find variant image
            if (activeVariant.featured_image) {
                // change active slide
                mainSwiper.slideTo(activeVariant.featured_image.position - 1);
            }
        }
    } catch (e) {
        console.warn("Variant image unable to update");
        console.error(e);
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// if variant url, update product on load to show variant gallery
if (window.location.href.includes("variant=") && document.querySelector('.productV8VisualSwiper')) {
    document.querySelector('.productV8Visual').classList.remove('mainVisual');
}

// update color title if available on load
if (document.querySelector('.productV8OptionItemValues.color') && document.querySelector('.productV8OptionItemLabelTitle')) {
    document.querySelector('.productV8OptionItemLabelTitle').textContent = document.querySelector('.productV8OptionItemValues.color .productV8OptionItemValuesLabelInput:checked').value;
}

/*
 * Disable size options that are not available for the selected color
 */
function updateUnavailableOptions() {
    // if the product option has Colour and Size
    if (product.options.length !== 2) {
        return;
    }

    // make sure the 1st option is color
    if (product.options[0] !== "Colour" && product.options[0] !== "Color") {
        return;
    }

    // make sure the 2nd option is size
    if (product.options[1] !== "Size") {
        return;
    }

    // collect options from inputs
    const options = [];
    document.querySelectorAll(`.productV8OptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    // get the current selected color and size
    const selectedColor = options[0];
    const selectedSize = options[1];

    // loop over ever size input
    document.querySelectorAll('.productV8OptionItem[data-value="Size"] .productV8OptionItemValuesLabelInput').forEach(sizeInput => {
        // skip if this is the selected size since we don't want to disable an option that is selected
        if (sizeInput.value === selectedSize) return;

        // get the size value in the loop
        const sizeValue = sizeInput.value;

        // create array of options BUT with the current size in the loop
        const testOptions = [selectedColor, sizeValue];

        // check if a variant exists with these options
        const testVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(testOptions)
        });

        // if the variant doesn't exist or isn't available, disable the size option
        sizeInput.disabled = testVariant === null || testVariant === undefined || !testVariant.available;
    });
}

// update on load
updateUnavailableOptions();

// find an available size
function nextAvailableSize() {

    // ensure product has two options, behavior on only size is disruptive
    if (product.options.length !== 2) {
        return;
    }

    // get all size inputs
    const sizeInputs = document.querySelectorAll('.productV8OptionItem[data-value="Size"] .productV8OptionItemValuesLabelInput');

    for (let input of sizeInputs) {
        // if one is not disabled or selected, activate
        if (!input.disabled && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('input', {bubbles: true}));
            return true;
        }
    }
    // none found
    return false;
}

/**************
 Product ATC
 ***************/

document.querySelector(".productV8Form").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector(".productV8FormATC").classList.add("loading");

    // add product
    const addedProduct = await addProduct(new FormData(this));

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    document.querySelector(".productV8FormATC").classList.remove("loading");

    // open cart
    await openCart(addedProduct);
});

/**************
 Video section
 ***************/

if (document.querySelector(".productV8VideosSwiper")) {
    // set up the swiper
    new Swiper(document.querySelector(".productV8VideosSwiper"), {
        slidesPerView: 2.6,
        spaceBetween: 8,
        on: {
            slideChange: stopAllVideos
        }
    });

    // pause all videos and remove active state from all buttons
    function stopAllVideos() {
        document.querySelectorAll(".productV8VideosSwiperSlideVideo").forEach(video => {
            video.pause();
        });
        document.querySelectorAll(".productV8VideosSwiperSlideButton.active").forEach(btn => {
            btn.classList.remove("active");
        });
    }

    // delegated click handler — play the video for the clicked button
    document.querySelector('.productV8VideosSwiper').addEventListener('click', async function (e) {
        const button = e.target.closest('.productV8VideosSwiperSlideButton');
        if (!button) return;

        const slide = button.closest('.productV8VideosSwiperSlide');
        const video = slide.querySelector('.productV8VideosSwiperSlideVideo');
        if (!video) return;

        // if the video is playing, pause
        if (button.classList.contains('active')) {
            video.pause();
            button.classList.remove('active');
            return;
        }

        // stop any currently playing video before starting the new one
        stopAllVideos();

        await video.play();
        button.classList.add('active');
    });

    // remove active class from the button when its video finishes
    document.querySelectorAll('.productV8VideosSwiperSlideVideo').forEach(video => {
        video.addEventListener('ended', function () {
            this.closest('.productV8VideosSwiperSlide').querySelector('.productV8VideosSwiperSlideButton')?.classList.remove('active');
        });
    });
}

/**************
 Product Bottom
 ***************/

// show on scroll
let isVisible = false;
const productBottom = document.querySelector('.productV8Bottom');

// listen if the original ATC button is scrolled off screen
window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const buttonOffsetTop = productFormATC.offsetTop;

    if (scrollTop > buttonOffsetTop && !isVisible) {
        productBottom.classList.add('active');
        isVisible = true;
    } else if (scrollTop <= buttonOffsetTop && isVisible) {
        productBottom.classList.remove('active');
        isVisible = false;
    }
})

// update active variant on input changes
document.querySelectorAll(".productV8BottomOptionItem").forEach(function (el) {
    el.addEventListener("change", function () {
        // update top selection to match  bottom
        const value = el.value;
        document.querySelector(`.productV8OptionItemValuesLabel [value="${value}"]`).click();
        updateBottomVariant();
    });
})

// initial variant
let bottomVariant = activeVariant;

// currency
let bottomCurrency = document.querySelector('.productV8BottomPrice').textContent.split(" ")[1];

// update active variant
function updateBottomVariant() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV8BottomOptionItem`).forEach(select => {
        options.push(select.value);
    });

    // find new variant based on the options
    bottomVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (bottomVariant === null || bottomVariant === undefined) {
        document.querySelector(".productV8BottomATC").classList.add("disabled");
        document.querySelector(".productV8BottomATC").textContent = "Not Available";
        return;
    }

    // update variant
    document.querySelector('.productV8BottomVariant').value = bottomVariant.id;

    // update price
    document.querySelector(".productV8BottomPrice").textContent = price(bottomVariant.price) + ` ${bottomCurrency}`;

    // check if the variant is in stock
    if (bottomVariant.available) {
        document.querySelector(".productV8BottomATC").classList.remove("disabled")
        document.querySelector(".productV8BottomATC").textContent = "Add To Cart";
    } else {
        document.querySelector(".productV8BottomATC").classList.add("disabled");
        document.querySelector(".productV8BottomATC").textContent = "Sold Out";
    }
}

// match variant on load
updateBottomVariant();

/**************
 Product ATC
 ***************/

document.querySelector(".productV8BottomRight").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector(".productV8BottomATC").classList.add("loading");

    // add product
    const addedProduct = await addProduct(new FormData(this));

    // remove loading animation
    document.querySelector(".productV8BottomATC").classList.remove("loading");

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // open cart
    await openCart(addedProduct);
});